import React from "react";
import { useTranslation } from "react-i18next";
import { Grid, Card, Typography, Stack, Button } from "@mui/material";
import SaudiRyal from "assets/saudiRyal";
import { useThemePalette } from "common/hooks/theme_palette";
import FileCopyIcon from "@mui/icons-material/FileCopy";

const FinancialStats = ({ data }) => {
  const { t } = useTranslation();
  const { primary } = useThemePalette();
  const labels = {
    remaining: t("financial.remaining"),
    transferred: t("financial.transferred"),
    total: t("financial.total"),
  };
  return (
    <Stack direction="column" alignItems={{ xs: "stretch", sm: "end" }} gap={2}>
      <Grid container spacing={3}>
        {Object.entries(data).map(([key, value], index) => (
          <Grid key={index} item xs={12} md={4}>
            <Card
              sx={{
                // height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
                // alignItems: "center",
                p: 4,
                borderRadius: 2,
                boxShadow: "0px 0px 10px rgba(0,0,0,0.05)",
              }}
            >
              <Typography variant="h6" sx={{ color: primary }} gutterBottom>
                {labels[key]}
              </Typography>
              <Typography variant="h2" fontWeight="bold">
                {value} <SaudiRyal />
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Button
        variant="contained"
        sx={{
          backgroundColor: primary,
          color: "white",
          "&:hover": { backgroundColor: primary },
          borderRadius: "8px",
          textTransform: "none",
        }}
        endIcon={<FileCopyIcon />}
      >
        {t("financial.copy_of_transfer_receipt")}
      </Button>
    </Stack>
  );
};

export default FinancialStats;
